import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';

import './GridBannerPreviewButton.css';
import * as keyset from './GridBannerPreviewButton.i18n';

const i18n = i18nFactory(keyset);

export interface GridBannerTextPreviewProps {
    onClick: () => void;
    bannersCount: number;
    cls?: string;
}

const BLOCK = 'grid-banner-preview-button';

export class GridBannerPreviewButton extends React.PureComponent<
    GridBannerTextPreviewProps
> {
    render() {
        const { onClick, bannersCount, cls } = this.props;

        return (
            <div
                className={classNames(cls, Bem.cls(BLOCK), TestBem.cls(BLOCK))}
                onClick={onClick}
            >
                {i18n('banners-count', {
                    count: bannersCount
                })}
            </div>
        );
    }
}
